import React, { useState } from 'react';
import { Table, Form, Pagination } from 'react-bootstrap';

const FileList = ({
    files,
    onEditFile,
    onDeleteFile,
    onSearch,
    onSort,
    sortConfig,
    currentPage,
    filesPerPage,
    totalFiles,
    paginate
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        onSearch(e.target.value);
    };

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(totalFiles / filesPerPage); i++) {
        pageNumbers.push(i);
    }

    const getSortDirection = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? '↑' : '↓';
        }
        return '';
    };

    /* const renderStatus = (File) => {
        if ('is_active' in File) {
            return File.is_active ?
                <Badge bg="success">Active</Badge> :
                <Badge bg="danger">Inactive</Badge>;
        }
        return <Badge bg="secondary">Unknown</Badge>;
    }; */

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    return (
        <>
            <div className="card-header d-flex justify-content-between align-items-center">
                <div></div>
                <div>
                    <Form.Control
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </div>

            </div>

            <div className="mb-2">
                (To Sort by the Information Column, Please Click on the Column Header)
            </div>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>

                        <th style={{ width: '250px' }} onClick={() => onSort('name')}>
                            File Name {getSortDirection('name')}
                        </th>
                        <th onClick={() => onSort('size')}>
                            Size {getSortDirection('size')}
                        </th>

                        <th onClick={() => onSort('uploadDate')}>
                            Vector Date
                            {getSortDirection('uploadDate')}
                        </th>
                        <th style={{ width: '150px' }} onClick={() => onSort('user_id')}>Vectored By  {getSortDirection('user_id')}</th>
                        {/* <th onClick={() => onSort('lastUsed')}>
                            Last Used
                            {getSortDirection('lastUsed')}
                        </th> */}
                        {/* 
                        <th onClick={() => onSort('uses')}>
                            Uses {getSortDirection('uses')}
                        </th> */}
                        <th onClick={() => onSort('visibility')}>
                            Visibility {getSortDirection('visibility')}
                        </th>

                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {files.map(file => (
                        <tr key={file.id}>

                            <td>{file.name}</td>
                            <td>{formatFileSize(file.size)}</td>
                            <td>{new Date(file.uploadDate).toLocaleDateString()}</td>
                            <td>{file.user_id}</td>
                            {/*  <td>{file.lastUsed || 'N/A'}</td> */}
                            {/* <td>{file.uses || 0}</td> */}
                            <td>{file.visibility}</td>
                            <td>

                                <div className="d-flex gap-2">
                                    <button
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={() => onEditFile(file)}
                                    >
                                        <i className="bi bi-pencil"></i>
                                    </button>
                                    <button
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() => onDeleteFile(file)}
                                    >
                                        <i className="bi bi-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <div className="card-footer d-flex justify-content-between align-items-center bg-white">
                <div>
                    <Pagination>
                        {pageNumbers.map(number => (
                            <Pagination.Item key={number} active={number === currentPage} onClick={() => paginate(number)}>
                                {number}
                            </Pagination.Item>
                        ))}
                    </Pagination>
                </div>
            </div>
        </>
    );
};

export default FileList;